import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PageContainer } from 'src/components/layout/page-containers';
import { AiAgentAnalyticsAgentFilter } from 'src/components/pages/ai-agents/analytics/components/ai-agent-analytics-agent-filter';
import {
  AiAgentAnalyticsFilters,
  AiAgentAnalyticsFiltersProvider,
} from 'src/components/pages/ai-agents/analytics/components/ai-agent-analytics-filters';
import { useAddBreadcrumb } from 'src/hooks/use-add-breadcrumb';
import { useAuthorization } from 'src/hooks/use-authorization';

const EmptyState = styled.div`
  color: ${({ theme }) => theme.colors.flint};
  padding: 30px;
`;

export const AnalyticsPage = memo(() => {
  const { t } = useTranslation(['aiAgents']);
  const { hasPermission } = useAuthorization();
  useAddBreadcrumb(t('aiAgents:pages.analytics.breadcrumb'));

  return (
    <PageContainer data-lgg-id="ai-agents-analytics-page">
      <AiAgentAnalyticsFiltersProvider>
        <AiAgentAnalyticsFilters>
          {hasPermission('ai:company.ai_agent:read:all') && (
            <AiAgentAnalyticsAgentFilter />
          )}
        </AiAgentAnalyticsFilters>
        <EmptyState>{t('aiAgents:pages.analytics.empty')}</EmptyState>
      </AiAgentAnalyticsFiltersProvider>
    </PageContainer>
  );
});
